<template>
  <div style="position: relative">
    <div>
      <div class="message-title">
        <div class="title-text">报文详情</div>
      </div>
      <div class="message-content">
        <div class="content-left">
          <div class="left-item">
            <div class="item-title">时间</div>
            <div class="item-content">{{ time }}</div>
          </div>
          <div class="left-item">
            <div class="item-title">类型</div>
            <div class="item-content">{{ exchangeType }}</div>
          </div>
          <!-- <div class="left-item">
            <div class="item-title">桩编码</div>
            <div class="item-content">{{ connectorId }}</div>
          </div> -->
          <div
            class="left-item"
            v-for="(item, index) in messageDetail"
            :key="index"
            :id="item.id"
          >
            <div class="item-title">{{ item.key }}</div>
            <div class="item-content">{{ item.value }}</div>
          </div>
        </div>
        <div class="content-bottom">
          <div class="bottom-item">
            <div class="bottom-title">原始报文</div>
            <div class="bottom-text">{{message}}</div>
          </div>
        </div>
      </div>
    </div>
    <el-button
      type="primary"
      plain
      style="position: absolute; right: 30px; top: -40px"
      @click="cancel()"
      >返回</el-button
    >
  </div>
</template>

<script>
import { HOST, EV_HOST } from "@/utils/host";
export default {
  name: "AddEnterprise",
  components: {},

  data() {
    return {
      id: "",
      time: "",
      message: "",
      num: "",
      exchangeType: "",
      messageDetail: [],
    };
  },
  computed: {},
  mounted() {
    this.getDataDetail();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data.id;
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    cancel() {
      this.$router.go(-1);
    },

    getDataDetail() {
      const data = {
        id: this.id,
      };
      this.$store.dispatch("form/handle", {
        url: "/msglog/messageLog/selectOne",
        data: data,
        method: "get",
        callback: (resp) => {
          this.time = resp.time;
          this.message = resp.message;
          this.exchangeType = resp.exchangeType;
          this.messageDetail = resp.parseData;
          this.messageDetail.forEach((item,index)=> {
            if(item.key == "bytes"){
              this.messageDetail.splice(index,1)
            }
          })
        },
      });
    },
  }, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.message-title {
  width: 100%;
  height: 70px;
  background-color: #f2f2f2;
  .title-text {
    font: 20px/70px "";
    padding-left: 20px;
  }
}
.message-content {
  width: 95%;
  padding: 20px 1%;
  display: flex;
  flex-direction: column;

  .content-left {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .left-item {
      width: 45%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 40px;

      .item-title {
        width: 20%;
        text-align: right;
        margin-right: 20%;
        font-weight: 700;
      }
      .item-content {
        width: 60%;
      }
    }
  }
  .content-bottom{
    padding-top: 40px;
    .bottom-item{
      display: flex;
      .bottom-title{
        width: 9%;
        text-align: right;
        margin-right: 9%;
        font-weight: 700;
      }
      .bottom-text{
        width: 80%;
        word-break:break-all;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/logDetail.vue